import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var CalendarRecurring = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_CalendarRecurring_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.833 9.67a3.001 3.001 0 0 1 4.72 1.33h-.863a.25.25 0 0 0-.208.389l1.533 2.299a.25.25 0 0 0 .416 0l1.533-2.3a.25.25 0 0 0-.208-.388h-1.16a4.002 4.002 0 0 0-6.52-2c-.207.183-.185.502.022.685.207.183.52.159.735-.015ZM6.849 13h-1.16a.25.25 0 0 1-.207-.389l1.533-2.299a.25.25 0 0 1 .416 0l1.533 2.3a.25.25 0 0 1-.208.388h-.863a3.001 3.001 0 0 0 4.72 1.33c.214-.174.528-.198.735-.015.207.183.228.502.021.684a4.002 4.002 0 0 1-6.52-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0a.5.5 0 0 1 .5.5V1h5V.5a.5.5 0 0 1 1 0V1c1.482.001 2.26.02 2.862.327a3 3 0 0 1 1.311 1.311c.27.53.317 1.197.325 2.362H16v2.5a.5.5 0 0 1-1 0V6H1v5.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18.36.03.934.036 1.589.038a.5.5 0 0 1 0 1c-1.39-.004-2.287-.034-2.862-.327a3 3 0 0 1-1.311-1.311C0 13.72 0 12.88 0 11.2V5h.002C.01 3.835.057 3.169.327 2.638a3 3 0 0 1 1.311-1.311C2.24 1.02 3.018 1.001 4.5 1V.5A.5.5 0 0 1 5 0Zm9.998 5a15.129 15.129 0 0 0-.036-1.089c-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C12.693 2.005 12.196 2 11.5 2v1a.5.5 0 0 1-1 0V2h-5v1a.5.5 0 0 1-1 0V2c-.696 0-1.193.005-1.589.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819-.024.294-.033.643-.036 1.089h13.996Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_CalendarRecurring_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default CalendarRecurring;